// import url from 'url';
import { GENERIC_ERROR_MESSAGE } from '../constants';

/**
 * Makes a fetch request to a provided uri. Generally used with autocomplete
 * location fields using the geoAC microservice
 * (https://wiki.zr.org/geoac#v1autocomplete-location-autocompletion)
 *
 * @param {String} uri - uri for request
 * @param {String} location - location string for the autocomplete. Default is empty string.
 * @param {String} selectCode - optional query string argument for geoAC, specifies what type of results to return.
 *
 */
export async function fetchLocationResults(uri, location = '', selectCode = '') {
  const fetchInit = {
    // method: 'GET',
    // mode: 'same-origin',
    // credentials: 'same-origin',
    // headers: {
    //   'X-Requested-With': 'XMLHttpRequest',
    // },
    // body: body ? serializeFormData(body) : undefined,
  };

  try {
    const response = await fetch(`${uri}${location ? `&location=${location}` : ''}${selectCode ? `&select_code=${selectCode}` : ''}`, fetchInit);

    const json = await response.json();

    // handle server errors
    if (!response.ok) {
      throw json;
    }

    return json.results;
  } catch (error) {
    const { stack } = error;
    const e = error;
    e.message = GENERIC_ERROR_MESSAGE;
    e.stack = stack;
    throw e;
  }
}

export default fetchLocationResults;
